import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Topbar from "./Topbar";
import Footer from "./Footer";

const API_URL = process.env.REACT_APP_API_URL;

/** Rough reading-time estimate from HTML body (200 wpm). */
const estimateReadingTime = (html = "") => {
  const plain = html.replace(/<[^>]+>/g, " ").trim();
  const words = plain ? plain.split(/\s+/).length : 0;
  return Math.max(1, Math.round(words / 200));
};

export default function ArticleDetail() {
  const { name } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(
          `${API_URL}/api/articles/detail/${encodeURIComponent(name)}`
        );
        if (res.ok) setArticle(await res.json());
      } catch (err) {
        console.error("Error fetching article:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, [name]);

  return (
    <div className="detail-page">
      <Topbar />

      {loading ? (
        <div className="loader-wrap"><div className="loader" /></div>
      ) : !article ? (
        <div className="shell" style={{ padding: "6rem 0", textAlign: "center" }}>
          <p className="empty-state">Article not found.</p>
          <Link to="/ViewArticles" className="btn-outline">Back to Articles</Link>
        </div>
      ) : (
        <>
          <div className="shell detail-top">
            <Link to="/ViewArticles" className="detail-back">All Articles</Link>
          </div>

          <header className="detail-hero">
            <div className="detail-hero-inner">
              <span className="detail-kicker">
                <span>Essay</span>
                <span className="sep" />
                <span>
                  {new Date(article.date).toLocaleDateString("en-US", {
                    month: "long", day: "numeric", year: "numeric",
                  })}
                </span>
                <span className="sep" />
                <span>{estimateReadingTime(article.content)} min read</span>
              </span>
              <h1 className="detail-title">{article.name}</h1>
              {article.description && (
                <p className="detail-deck">{article.description}</p>
              )}
              <hr className="detail-rule" />
            </div>
          </header>

          <article
            className="detail-content"
            dangerouslySetInnerHTML={{ __html: article.content || "" }}
          />

          <div className="detail-close">
            <span className="detail-close-meta">End of article</span>
            <Link to="/ViewArticles" className="link-arrow">More Articles</Link>
          </div>
        </>
      )}

      <Footer />
    </div>
  );
}
